import React, { useState, useEffect } from 'react';
import { useLanguage } from 'Context/LanguageContext';
import Grid from '@mui/material/Grid2';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useNavigate } from 'react-router-dom';
import { ENDPOINTS } from '../../core/constants/pageEndpoints.constants';
import { selectSession } from '../../core/store/modules/session/sessionSelectors';
import AssetInventoryHeader from './components/AssetInventoryHeader';
import AssetInventoryTitles from './components/AssetInventoryTitles';
import CreateFieldsAssetInventory from './components/CreateFieldsAssetInventory';
import TemplateFilesGenerator from './components/TemplateFilesGenerator';
import EditForm from './EditForm';
import { checkCustomTemplateType } from './util';
import  LinkAssetInventory from 'OldComponents/AssetInventory/components/LinkAssetInventory';
import { useSelector } from 'react-redux';
import { Button } from '@mui/material';

const TaskAssets = ({
	assets,
	activeAsset,
	assetHasImages,
	images,
	changeActiveAsset,
	client,
	timezone,
	reloadData,
	taskData,
	taskAgent,
	idAccountTask
}) => {
	const lan = useLanguage();
	const navigate = useNavigate();
	const session = useSelector(selectSession);
	const [editAsset, setEditAsset] = useState(false);
	const [customTemplateType, setCustomTemplateType] = useState({ xslx: false, html: false });
	const [showAssetInventoryFileField, setShowAssetFieldFile] = useState({});
	const [showAssetInventoryFileQuestion, setShowAssetFieldQuestion] = useState({});
	useEffect(() => {
		const customTypes = checkCustomTemplateType(assets[activeAsset]);
		setCustomTemplateType(customTypes);
	}, [activeAsset, assets]);
	const viewAsset = () => {
		const asset = assets[activeAsset];
		navigate(`${ENDPOINTS.assetManagement}?id=${asset.id}`);
	};
	const editAssetVisibility = () => {
		setEditAsset(!editAsset);
	};
	const getTextFile = async (question, isField) => {
		let getTextFromFile = () => {
			return new Promise((res, rej) => {
				let request = new XMLHttpRequest();
				request.open('GET', question.file, true);
				request.send();
				request.onreadystatechange = () => {
					if (request.readyState === 4 && request.status == '200') {
						let type = request.getResponseHeader('Content-Type');
						if (type.indexOf('text') != 1) {
							res(request.response);
						}
					}
				};
			});
		};
		let text = await getTextFromFile();
		
		if (isField) {
			let showAssetField = {}
			showAssetField[question.id] = text
			setShowAssetFieldFile(Object.assign(showAssetField))
		} else {
			let showAssetQuestion = {}
			showAssetQuestion[question.id] = text
			setShowAssetFieldQuestion(Object.assign(showAssetQuestion))
		 }
		
	};
	const Header = (
		<AssetInventoryHeader
			isAsset
			showFormFile={showAssetInventoryFileField}
			assetInventories={assets}
			activeAssetInventory={activeAsset}
			timezone={timezone}
			getTextFileHeader={getTextFile}
		/>
	);
	return (
		<Grid container>
			{editAsset && (
				<EditForm
					idAccountTask={idAccountTask}
					asset={assets[activeAsset]}
					onClose={editAssetVisibility}
					Header={Header}
					taskId={taskData.idFielder}
					reloadData={reloadData}
					session={session}
					client={client}
					lan={lan}
					taskData={taskData}
				/>
			)}
			<Grid size={12} container sx={{ height: '70%', minHeight: '300px' }}>
				<Grid size={3}>
					<Scrollbars renderThumbHorizontal={(props) => <div {...props} style={{ display: 'none' }} />}>
						<AssetInventoryTitles
							assetInventories={assets}
							activeAssetInventory={activeAsset}
							changeActiveAssetInventory={changeActiveAsset}
							client={client}
							editAssetInventoryVisibility={editAssetVisibility}
							isAsset
						/>
					</Scrollbars>
				</Grid>
				<Grid size={9}>
					<Scrollbars renderThumbHorizontal={(props) => <div {...props} style={{ display: 'none' }} />}>
						<AssetInventoryHeader
							isAsset
							showFormFile={showAssetInventoryFileField}
							assetInventories={assets}
							activeAssetInventory={activeAsset}
							timezone={timezone}
							getTextFileHeader={getTextFile}
						/>
						<CreateFieldsAssetInventory
							assetInventories={assets}
							activeAssetInventory={activeAsset}
							timezone={timezone}
							showFormFile={showAssetInventoryFileQuestion}
							getTextFileHeader={getTextFile}
						/>
						<LinkAssetInventory
							idAsset={assets[activeAsset].id}
							showInventorySearch={false}
							action={'update'}
							showDeleteIcon={false}
							idTask={taskData.idFielder}
							reloadData={reloadData}
							idAccountTask={taskData.idAccount}
						/>
						</Scrollbars>
				</Grid>
			</Grid>
      {assets && (
        <Grid size={12} container spacing={1} direction="row" sx={{ justifyContent: "center", alignItems: "center" }}>
          <Grid size={4}>
            <Button
              variant="outlined"
              onClick={viewAsset}
              size={'medium'}
            >
              {lan.viewAsset}
            </Button>
          </Grid>
          <Grid size={8}>
            <TemplateFilesGenerator
              customTemplateType={customTemplateType}
              taskData={taskData}
              taskAgent={taskAgent}
              asset={assets[activeAsset]}
              hasImages={assetHasImages}
              images={images}
            />
          </Grid>
        </Grid>
      )}
		</Grid>
	);
};
export default TaskAssets;
